var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgLink = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M24 47.5c12.979 0 23.5-10.521 23.5-23.5S36.979.5 24 .5.5 11.021.5 24 11.021 47.5 24 47.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32.5c1.2-1.2 1.8-2.8 1.8-4.4l-1.4 1.4c-.2.8-.6 1.6-1.3 2.2l-1.7 1.7c-.9.9-2.1 1.4-3.3 1.4-1.1 0-2.1-.4-2.8-1.1-.8-.8-1.2-1.9-1.1-3 0-1.1.5-2.2 1.4-3.1l1.7-1.7c.6-.6 1.4-1 2.2-1.3l1.4-1.4h-.2c-1.5 0-3.1.7-4.2 1.8l-1.7 1.7c-1.1 1.1-1.7 2.5-1.8 4s.4 2.8 1.4 3.8 2.4 1.5 3.8 1.4c1.5-.1 2.9-.7 4-1.8zM29.4 23.498l-1.4 1.4c1.6 0 3.2-.6 4.4-1.8l1.7-1.7c2.3-2.3 2.4-5.8.4-7.8-2.1-2.1-5.6-1.9-7.8.4l-1.7 1.5c-1.2 1.2-1.8 2.8-1.8 4.4l1.4-1.4c.2-.8.6-1.6 1.3-2.2l1.7-1.7c.8-.8 1.9-1.3 3.1-1.4 1.1 0 2.2.4 3 1.1.8.8 1.2 1.9 1.1 3 0 1.1-.5 2.2-1.4 3.1l-1.7 1.7c-.7.7-1.4 1.2-2.3 1.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 27.9c-.1.1-.2.3-.2.5s.1.3.2.5c.2.2.7.2.9 0l8.7-8.7c.2-.2.2-.4.2-.6s-.1-.3-.2-.5c-.1-.1-.3-.1-.4-.1-.2 0-.3.1-.5.2z"
  })));
};
const Memo = /*#__PURE__*/memo(SvgLink);
export default Memo;